<template>
  <NotificationBadge v-if="attestationCount > 0" :count="attestationCount"/>
</template>

<script>
import { computed } from '@vue/composition-api';
import { useStore } from '@vue3shims';
import NotificationBadge from '@atoms/v2/NotificationBadge.vue';

export default {
  setup() {
    const store = useStore();
    const accountType = computed(() => store.getters['accountType']);
    const attestationConfirmationsPending = computed(() => store.getters['attestationConfirmationsPending']);
    const attestationRequestsPending = computed(() => store.getters['attestationRequestsPending']);
    const attestationCount = computed(() => {
      if(['B', 'T'].includes(accountType.value)) {
        return attestationConfirmationsPending.value || 0;
      }
      else if(accountType.value === 'C') {
        return attestationRequestsPending.value || 0;
      }
      return 0;
    });

    return {
      attestationCount,
    }
  },
  components: {
    NotificationBadge,
  },
}
</script>

<style>

</style>